<!--- MENU ---->
<ion-menu contentId="principal" id="menu_principal" menuId="menu_principal" color="light">
  <ion-header>
    <ion-toolbar>
      <ion-icon slot="start" class="icon-menu" src="/assets/icon/user.svg"></ion-icon>
      <ion-buttons slot="start">
        <ion-button (click)="pushPainelUsuarioLogado()" class="btn-perfil-usuario">
          <ion-label class="label-name-usuario" text-wrap>{{conta_logada.nome}}</ion-label>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-content>
    <ion-list>
      <ion-item (click)="pushPage('home')" *ngIf="acessoPainel !== undefined">
        <ion-icon name="apps-outline" slot="start"></ion-icon>
        <ion-label>Painel</ion-label>
      </ion-item>

      <!-- Menu dinâmico hierárquico -->
      <ng-container *ngFor="let item of menuItems">
        <ng-container *ngTemplateOutlet="menuItemTemplate; context: { item: item, level: 0 }"></ng-container>
      </ng-container>

      <ion-item (click)="logout()">
        <ion-icon name="exit" slot="start"></ion-icon>
        <ion-label>Sair</ion-label>
      </ion-item>
    </ion-list>
  </ion-content>
  <ion-img class="logo-menu" src="assets/image/protix-logo.png"></ion-img>
</ion-menu>
<ion-router-outlet id="principal"></ion-router-outlet>

<!-- Template recursivo para itens de menu -->
<ng-template #menuItemTemplate let-item="item" let-level="level">
  <!-- Exibe o item se:
       - For módulo (sempre exibe)
       - Tiver acesso direto
       - Tiver filhos (itens intermediários sem acesso próprio)
  -->
  <ng-container *ngIf="item.isModulo || item.possui_acesso || hasChildren(item)">
    <!-- Item de módulo (sempre renderiza, com ou sem filhos) -->
    <ng-container *ngIf="item.isModulo">
      <ion-item 
        (click)="hasChildren(item) ? toggleMenu(item) : null" 
        [class.submenu-item]="level > 0">
        <!-- Ícone do módulo -->
        <ion-icon 
          [name]="getIconForModulo(item.modulo_path)" 
          slot="start">
        </ion-icon>
        <!-- Ícone de expansão - só aparece se tiver filhos -->
        <ion-icon 
          [name]="isExpanded(item) ? 'chevron-down-outline' : 'chevron-forward-outline'" 
          slot="end"
          *ngIf="hasChildren(item)">
        </ion-icon>
        <ion-label>{{item.nome_path}}</ion-label>
      </ion-item>
      
      <!-- Submenu (filhos) - SÓ aparece se o item estiver expandido E tiver filhos -->
      <ion-item-group 
        submenu 
        [class.visible]="isExpanded(item)"
        [class.level-1]="level === 0"
        *ngIf="hasChildren(item)">
        <ng-container *ngFor="let filho of item.filhos">
          <ng-container *ngTemplateOutlet="menuItemTemplate; context: { item: filho, level: level + 1 }"></ng-container>
        </ng-container>
      </ion-item-group>
    </ng-container>
    
    <!-- Item de menu com filhos (submenu expansível) - NÃO módulos -->
    <!-- IMPORTANTE: Esta condição deve vir ANTES do item final para priorizar itens expansíveis -->
    <ng-container *ngIf="!item.isModulo && hasChildren(item)">
      <ion-item 
        (click)="toggleMenu(item)" 
        [class.submenu-item]="level > 0"
        style="cursor: pointer;">
        <!-- Ícone do módulo para itens de nível 2 (mesmo ícone do módulo pai) -->
        <ion-icon 
          [name]="getIconForModulo(item.modulo_path)" 
          slot="start"
          *ngIf="level === 1">
        </ion-icon>
        <ion-label>{{item.nome_path}}</ion-label>
        <!-- Ícone de expansão/colapso - sempre aparece para itens com filhos, à direita -->
        <ion-icon 
          [name]="isExpanded(item) ? 'chevron-down-outline' : 'chevron-forward-outline'" 
          slot="end">
        </ion-icon>
      </ion-item>
      
      <!-- Submenu (filhos) - SÓ aparece se o item estiver expandido -->
      <ion-item-group 
        submenu 
        [class.visible]="isExpanded(item)"
        [class.level-2]="level === 1">
        <ng-container *ngFor="let filho of item.filhos">
          <ng-container *ngTemplateOutlet="menuItemTemplate; context: { item: filho, level: level + 1 }"></ng-container>
        </ng-container>
      </ion-item-group>
    </ng-container>

    <!-- Item de menu sem filhos (item final) - só exibe se tiver acesso, não for módulo, tiver path E não tiver filhos -->
    <!-- IMPORTANTE: Esta condição deve vir DEPOIS do item expansível -->
    <ion-item 
      (click)="pushPage(item.path!)" 
      *ngIf="!item.isModulo && !hasChildren(item) && item.possui_acesso && item.path"
      [class.submenu-item]="level > 0">
      <!-- Ícone do módulo para itens raiz do módulo (nível 0 ou 1, path_acesso_pai_id = NULL) -->
      <ion-icon 
        [name]="getIconForModulo(item.modulo_path)" 
        slot="start"
        *ngIf="level === 0 || level === 1">
      </ion-icon>
      <!-- Ícone padrão para itens filhos (nível 2+) -->
      <ion-icon 
        src="/assets/icon/open.svg" 
        slot="start"
        *ngIf="level > 1">
      </ion-icon>
      <ion-label>{{item.nome_path}}</ion-label>
    </ion-item>
  </ng-container>
</ng-template>